import { render, staticRenderFns } from "./WaBigNumber.vue?vue&type=template&id=d6326eee"
import script from "./WaBigNumber.vue?vue&type=script&lang=js"
export * from "./WaBigNumber.vue?vue&type=script&lang=js"
import style0 from "./WaBigNumber.vue?vue&type=style&index=0&id=d6326eee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports